import {AnyLinkType} from 'shared/pretty-easy-navigation/models';

export const ParentMenu: AnyLinkType[] = [
    {
        type: 'link',
        label: 'navigation.home',
        link: '/home',
        icon: 'navigation-link__home',
    },
    {
        type: 'linkGroup',
        label: 'navigation.contents',
        links: [
            {
                type: 'link',
                label: 'navigation.corpus',
                link: '/corpus/11057',
                icon: 'navigation-link__corpus',
            },
            {
                type: 'link',
                label: 'navigation.training',
                link: '/further/formations',
                icon: 'navigation-link__training',
            },
            {
                type: 'link',
                label: 'navigation.lessons_to_share',
                link: '/lessons/list',
                icon: 'navigation-link__lessons',
            },
        ],
    },
    {
        type: 'linkGroup',
        links: [
            {
                type: 'imageLink',
                label: 'navigation.offered_by',
                icon: 'navigation__offered-by',
                src: '{{OFFERED_BY_SRC}}',
                actionToken: '{{OFFERED_BY_ACTION}}',
            },
            {
                type: 'link',
                label: 'navigation.legal_notice',
                link: '/informations-legales',
                icon: 'navigation-link__legal-notice',
            },
            {
                type: 'link',
                label: 'navigation.contact',
                link: '/page/feedback',
                icon: 'navigation-link__contact',
            },
            {
                type: 'link',
                label: 'navigation.who_are_we',
                link: '/page/qui-sommes-nous',
                icon: 'navigation-link__who-are-we',
            },
            {
                type: 'link',
                label: 'navigation.site_map',
                link: '/page/site-map-parent',
                icon: 'navigation-link__sitemap',
            },
        ],
    },
];
